import { useEffect } from "react";

// Components
import FrontDevicesSection from "../../Components/Layouts/StaticInfo/FrontDevicesSection";
import FrontCommunitySection from "../../Components/Layouts/StaticInfo/FrontCommunitySection";
import FrontFinalCta from "../../Components/Layouts/StaticInfo/FrontFinalCta";
import FrontHero from "../../Components/Layouts/StaticInfo/FrontHero";
import FrontOriginalsSection from "../../Components/Layouts/StaticInfo/FrontOriginalsSection";
import FrontPresentersSection from "../../Components/Layouts/StaticInfo/FrontPresentersSection";
import FrontPricingSection from "../../Components/Layouts/StaticInfo/FrontPricingSection";
import FrontProofStrip from "../../Components/Layouts/StaticInfo/FrontProofStrip";
import FrontTrailerSection from "../../Components/Layouts/StaticInfo/FrontTrailerSection";
import FrontValueComparisonSection from "../../Components/Layouts/StaticInfo/FrontValueComparisonSection";
import FrontPresenterReelPopup from "../../Components/Popups/FrontPresenterReelPopup";
import FrontTrailerPopup from "../../Components/Popups/FrontTrailerPopup";

// Context
import { PopupType, usePopup } from "../../Context/PopupContext";

// Helpers
import { SetTitle } from "../../Helpers/PageMetadata";

// Hooks
import useFetchSubscriptionPlans from "../../Hooks/Plans/useFetchSubscriptionPlans";

// Models
import PublicAuthorDTO from "../../Models/DTOs/PublicAuthorDTO";

const FrontPage = () => {
    const { openPopup } = usePopup();
    const { plans, plansLoading, plansError } = useFetchSubscriptionPlans();

    useEffect(() => {
        SetTitle("Question Everything");
    }, []);

    const openTrailer = () => {
        openPopup(PopupType.FRONT_TRAILER);
    };

    const openPresenterReel = (author: PublicAuthorDTO) => {
        openPopup(PopupType.FRONT_PRESENTER_REEL, author);
    };

    return (
        <div className="page--front">
            <FrontHero onOpenTrailer={openTrailer} plans={plans} />
            <FrontProofStrip />
            <FrontCommunitySection />
            <FrontTrailerSection onOpenTrailer={openTrailer} />
            <FrontPresentersSection onOpenReel={openPresenterReel} />
            <FrontOriginalsSection />
            <FrontValueComparisonSection
                plans={plans}
                plansLoading={plansLoading}
                plansError={plansError}
            />
            <FrontDevicesSection />
            <FrontPricingSection
                plans={plans}
                plansLoading={plansLoading}
                plansError={plansError}
            />
            <FrontFinalCta plans={plans} />
            <FrontPresenterReelPopup />
            <FrontTrailerPopup />
        </div>
    );
};

export default FrontPage;
